<template>
    <b-modal dialog-class="modal-pax" ref="modal-suggestion" hide-footer id="paxModalSelection">
        <template v-slot:modal-title>
            {{ $t("pax.suggestion_pax") }}
        </template>

        <div v-if="processing">
        	<LoadingSpinner class="col-12" />
        </div>

       	<template v-else>
	    	<!-- <div class="stallionGrade" v-for="stallion in stallions_suggestion" :key="stallion.horse_id" :class="callColorGrade(stallion.horse_id)">
				<div class="row no-gutters align-items-center" >
					<div class="col-5">
						<div class="stallionName">{{ stallion.horse_nom }}</div>
					</div>
					<div class="col-7 text-center">
						<span class="bullet" v-for="critere in criteres" :class="getColorBullets(stallion.horse_id, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
					</div>
				</div>
			</div> -->

			<div class="stallionGradeV2" v-for="stallion in stallions_suggestion" :key="stallion.horse_id">
				<div class="row align-items-center">
					<div class="col-10">
						<div :class="getGlobalColor(callColorGrade(stallion.horse_id), colorGeneticIndicator(stallion.horse_id))" class="stallionName">{{ stallion.horse_nom }}</div>
					</div>
					<div class="col-1">
						<div :class="colorGeneticIndicator(stallion.horse_id)" class="stallionName"><font-awesome-icon :icon="['far', 'hourglass']"/></div>
					</div>
					<div class="col-1">
						<div :class="callColorGrade(stallion.horse_id)" ><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
					</div>
				</div>
			</div>

			<div class="text-center mt-2">
				<button class="btn btn-pax" @click="sendStallionsSelected">{{ $t('pax.modifier_selection') }}</button>
			</div>
		</template>
    </b-modal>
</template>


<script type="text/javascript">
	import PaxMixin from "@/mixins/Pax.js"
	import _cloneDeep from 'lodash/cloneDeep';
	import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'PaxSuggestion',
		mixins: [PaxMixin, Navigation],
		props: {
			criteres: {
				type: Array,
				default: () => ( [] )
			},
			stallions: {
				type: Array,
				default: () => ( [] )
			},
			stallions_available: {
				type: Array,
				default: () => ( [] )
			},
			mare: {
				type: Object,
				default: () => ( null )
			},
			suggestion: {
				type: Array,
				default: () => ( [] )
			}
		},
		data () {
			return {
				stallions_suggestion: [],
				recap: [],
				processing: false,
				genetic_indicators: [],
				genetic_loaded: true
			}
		},

		methods: {
			openModal() {
				this.$refs['modal-suggestion'].show()
				this.calculSuggestion()
			},
			
			callColorGrade(stallion_id) {
				return this.colorGrade(stallion_id, this.recap, this.criteres)
			},

			async calculSuggestion() {
				this.$refs['modal-suggestion'].show()
				this.processing = true

				const country = this.getConfig('country')
				const stallions_ids = this.stallions.map(stallion => stallion.horse_id)

				// const all_stallions = await this.getStallions()
				const all_stallions = this.stallions_available
				const stallions = all_stallions.filter(stallion => {
					let countries = stallion.horse_pays
					return countries.indexOf(parseInt(country.id)) > -1 && !stallions_ids.includes(stallion.horse_id)
				})

				this.recap = await this.paxCalculCompatiblite(stallions, this.criteres)
				const notation = await this.getPaxColor(this.recap, this.criteres)
				const notation_sort = Object.entries(notation).sort((a,b) => b[1]-a[1]).slice(0, 5)

				this.stallions_suggestion = []
				notation_sort.forEach(stallion => {
					this.stallions_suggestion.push(stallions.find(s => s.horse_id == stallion[0]))
				})
				await this.calculGeneticIndicator()
				this.processing = false
			},

			async calculGeneticIndicator() {
				const stallions_ids = this.stallions_suggestion.map(stallion => stallion.horse_id)
				if(!this.mare || stallions_ids.length == 0) return false
				this.genetic_indicators = await this.getGeneticIndicator(this.mare.horse_id, stallions_ids.join(','))
			},

			colorGeneticIndicator(stallion_id) {
				return Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id].genetic_indicator_color : 'lightgray'
			},

			sendStallionsSelected() {
				this.$emit('update:suggestion', this.stallions_suggestion)
				this.$refs['modal-suggestion'].hide()
			}
		},
		components: {
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
		}
	}

</script>